import { all, fork } from "redux-saga/effects";

import homeSagas from "../home/sagas";

export default function* rootSaga() {
  yield all([
    fork(homeSagas)
  ]);
}
